export const SET_BRIEFS_LOADING     = 'SET_BRIEFS_LOADING';
export const SET_PRODUCT            = 'SET_PRODUCT';
export const SET_PLUGIN_INFO        = 'SET_PLUGIN_INFO';
export const SET_BRIEFS             = 'SET_BRIEFS';
export const SET_ADOBE_RATING       = 'SET_ADOBE_RATING';
export const SET_RATING_LOADING     = 'SET_RATING_LOADING';
export const SET_RATING_PAGINATION  = 'SET_RATING_PAGINATION';
export const SET_RATING_PREVIEW     = 'SET_RATING_PREVIEW';
export const SET_RATING_HISTORY     = 'SET_RATING_HISTORY';
export const SET_RATING_LIKE        = 'SET_RATING_LIKE';